/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - European Union 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [user-link.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 29.08.18 18:26
 */

import moment from 'moment';

import React from 'react';
import {getUserAvatar} from "../../actions/environment";
import {useLanguage} from "../configuration/configuration";
import {HtmlTooltipLink, TooltipLink} from "../navigation/buttons/nav-buttons";
import {ImageBoxSmall} from "../boxes/image-box-small";
import {NavigationGroup, NavigationRow} from "../navigation/layout/nav-layout";
import {STATE_SHARED} from "../../actions/spaces";

// header for a post that has SHARED_STATUS
const SpaceLink = ({allowComments, post: {user, created, state, from, fromSpace}}) => {
    const Lang = useLanguage();

    const renderAvatar = (user, avatar) => {
        const image = avatar ? avatar : getUserAvatar(user);
        return <div className="avatar-tooltip" id="avatar-tooltip-id">
            <span title={user.fullname}><img src={image}/></span>
        </div>
    }

    const renderUser = (user, text) => {
        const avatar = getUserAvatar(user);
        return <div className='user-link'>
            <HtmlTooltipLink to={`/${user.username}/home`}
                             html={renderAvatar(user, avatar)}
                             htmlParams={{theme: 'avatar', placeholderId: 'avatar-tooltip-id'}}>
                {user.fullname}
            </HtmlTooltipLink>
            {allowComments && <span className="comment-created">{text} {moment(created).fromNow()}</span>}
        </div>
    }

    const renderSpace = () => {
        const image = fromSpace && fromSpace.media.length > 0 ? fromSpace.media[0].url : null;
        const spaceUrl = `/${user.username}/space/${fromSpace.id}`;

        return <TooltipLink to={spaceUrl} title={fromSpace.name}>
            <ImageBoxSmall size='small' image={image}/>
        </TooltipLink>
    }

    return <NavigationRow>
        <NavigationGroup>
            <div className='d-flex align-items-start'>
                {fromSpace && renderSpace()}
                <div>
                    <span className='sidebar-space-text ml-1'><b>{fromSpace.name}</b></span>
                    {(state === STATE_SHARED) && from && renderUser(from, Lang.userLink.shared)}
                </div>
            </div>
        </NavigationGroup>
    </NavigationRow>
}

export default SpaceLink;